import SplitType from 'split-type'
import { sel, selAll } from '../utils'
import gsap from 'gsap'

export default function standardHeader(dataPage) {
  const headerComp$ = selAll('#standard-hero')
  headerComp$.forEach((header) => {
    if (dataPage === 'epic') return
    const compInfo$ = header.querySelector('.comp-hero__info')
    const compP$ = header.querySelector('.comp-hero__p')
    const compBtnGroup$ = header.querySelector('.button-group')
    const compBtnW$ = compBtnGroup$.querySelector('.btn:not(.is--blur)')
    // console.log('compBtnW$', compBtnW$)
    const compBtnBlur$ = compBtnGroup$.querySelector('.btn.is--blur')
    const compBtnAlt$ = compBtnGroup$.querySelector('.btn.is--2nd')

    const compHeroBg$ = header.querySelector('.hero__bg-w img')
    const compSubtitle$ = header.querySelector('.comp-hero__subtitle')
    const compHsT = new SplitType('.comp-hero__h', { types: 'words, chars' })

    console.log('compHsT', compBtnW$)
    gsap
      .timeline()
      .from(compHeroBg$, { scale: 1.1, ease: 'power1.out', duration: 3 })
      .from(
        compHsT.chars,
        {
          opacity: 0,
          filter: 'blur(50px)',
          stagger: {
            amount: 0.5,
            // from: 'end',
          },
          duration: 0.5,
          ease: 'none',
          // ease: 'power1.out',
        },
        0.5
      )
      .from(compP$, { opacity: 0, ease: 'power1.out', duration: 1 }, '>-0.5')
      .from(compBtnW$, { autoAlpha: 0, ease: 'power1.out', duration: 1 }, '>-0.5')
      .fromTo(compBtnBlur$, { backdropFilter: 'blur(0px)', autoAlpha: 0 }, { autoAlpha: 1, backdropFilter: 'blur(10px)', duration: 1 }, '<+0.1')
      .from(compBtnAlt$, { autoAlpha: 0 }, '<')
      .from(compSubtitle$, { autoAlpha: 0, ease: 'power1.out', duration: 1 }, '>-0.5')
    // .from(navbar$, { autoAlpha: 0, ease: 'power1.out', duration: 1 }, '>-0.75')
  })
}
